import { Component, EventEmitter, HostBinding, HostListener, Input, Output, signal } from '@angular/core';

@Component({
  selector: 'tt-step',
  standalone: true,
  template: `
    @if (number(); as number) {
      <span class="tt-step_number">{{ number }}</span>
    }
    <ng-content />
  `,
})
export class StepComponent {
  @HostBinding('class.tt-step') public hostCls = true;

  @HostBinding('class.tt-step--selected')
  public get selectedClass(): boolean {
    return this.selected();
  }

  @HostBinding('class.tt-step--disabled')
  public get disabledClass(): boolean {
    return this._disabled();
  }

  @HostListener('click')
  public onClick(): void {
    if (this._disabled()) {
      return;
    }

    this.stepSelected.emit(this.value);
  }

  @Input() public value;

  private _disabled = signal(false);
  @Input() public set disabled(value: boolean) {
    this._disabled.set(value);
  }

  @Output() public stepSelected = new EventEmitter();

  public selected = signal(false);
  public number = signal(undefined);
}
